exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/integrate-loyalty-v2/integrate-loyalty-view-product/integrate-loyalty-view-product.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/integrate-loyalty-v2/integrate-loyalty-view-product/integrate-loyalty-view-product.component.css
// module chunks = 3